'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Immutable = require('Immutable');

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _PropertyFormHeader = require('MeetingsLib/components/header/PropertyFormHeader');

var _PropertyFormHeader2 = _interopRequireDefault(_PropertyFormHeader);

var _BookingFormFields = require('MeetingsLib/components/input/BookingFormFields');

var _BookingFormFields2 = _interopRequireDefault(_BookingFormFields);

var _StepButtonsFooter = require('MeetingsLib/components/page/StepButtonsFooter');

var _StepButtonsFooter2 = _interopRequireDefault(_StepButtonsFooter);

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

var _AutoSubmitSelector = require('MeetingsLib/selectors/AutoSubmitSelector');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _FormFieldValidationSelector = require('MeetingsLib/selectors/FormFieldValidationSelector');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropertyForm = _react2.default.createClass({
  displayName: 'PropertyForm',

  propTypes: {
    // passed
    compact: _react.PropTypes.bool,
    goToPreviousStep: _react.PropTypes.func.isRequired,
    submittingMeeting: _react.PropTypes.bool,
    //loaded
    canSubmitStagedPropertyForm: _react.PropTypes.bool,
    centerPropertyForm: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    dateTime: _react.PropTypes.number.isRequired,
    formFields: _react.PropTypes.instanceOf(_Immutable.List).isRequired,
    stagedFormState: _react.PropTypes.instanceOf(_FormState2.default),
    formStateValidation: _react.PropTypes.instanceOf(_Immutable.Map).isRequired,
    legalConsentEnabled: _react.PropTypes.bool.isRequired,
    offline: _react.PropTypes.bool,
    setFormValue: _react.PropTypes.func.isRequired,
    setFormState: _react.PropTypes.func.isRequired,
    resetFormState: _react.PropTypes.func.isRequired,
    userTimezone: _react.PropTypes.string.isRequired
  },

  componentDidMount: function componentDidMount() {
    (0, _UsageTracker.track)('meetingsLibViewScreen', { subscreen: 'form' });
  },
  shouldCenterForm: function shouldCenterForm() {
    var _props = this.props,
        compact = _props.compact,
        centerPropertyForm = _props.centerPropertyForm;

    return !compact && centerPropertyForm;
  },
  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _props2 = this.props,
        resetFormState = _props2.resetFormState,
        goToPreviousStep = _props2.goToPreviousStep;


    resetFormState();
    goToPreviousStep();
  },
  renderFormFields: function renderFormFields() {
    var _props3 = this.props,
        formFields = _props3.formFields,
        stagedFormState = _props3.stagedFormState,
        formStateValidation = _props3.formStateValidation,
        setFormValue = _props3.setFormValue;


    return _react2.default.createElement(
      'div',
      { className: 'form-body width-100 m-bottom-7 overflow-y-scroll overflow-x-hidden' },
      _react2.default.createElement(_BookingFormFields2.default, {
        centerPropertyForm: this.shouldCenterForm(),
        formFields: formFields,
        formState: stagedFormState,
        formStateValidation: formStateValidation,
        setFormValue: setFormValue
      })
    );
  },
  renderFormHeader: function renderFormHeader() {
    var _props4 = this.props,
        offline = _props4.offline,
        userTimezone = _props4.userTimezone,
        dateTime = _props4.dateTime;


    return _react2.default.createElement(_PropertyFormHeader2.default, {
      centerPropertyForm: this.shouldCenterForm(),
      offline: offline,
      userTimezone: userTimezone,
      dateTime: dateTime
    });
  },
  renderFormButtons: function renderFormButtons() {
    var _props5 = this.props,
        submittingMeeting = _props5.submittingMeeting,
        canSubmitStagedPropertyForm = _props5.canSubmitStagedPropertyForm,
        legalConsentEnabled = _props5.legalConsentEnabled,
        setFormState = _props5.setFormState,
        stagedFormState = _props5.stagedFormState;


    return _react2.default.createElement(_StepButtonsFooter2.default, {
      submittingMeeting: submittingMeeting,
      canProceed: canSubmitStagedPropertyForm,
      goToPreviousStep: this.handleGoToPreviousStep,
      goToNextStep: function goToNextStep() {
        return setFormState(stagedFormState);
      },
      isLastStep: !legalConsentEnabled
    });
  },
  render: function render() {
    return _react2.default.createElement(
      _UICard2.default,
      { className: 'height-100 p-y-6' },
      _react2.default.createElement(
        _UIFlex2.default,
        { className: 'height-100', direction: 'column', justify: 'around' },
        this.renderFormHeader(),
        this.renderFormFields(),
        this.renderFormButtons()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    canSubmitStagedPropertyForm: (0, _AutoSubmitSelector.canSubmitStagedPropertyForm)(state),
    centerPropertyForm: (0, _BookInfoSelectors.shouldCenterPropertyForm)(state),
    dateTime: (0, _BookInfoSelectors.getEvent)(state).dateTime,
    formFields: (0, _BookInfoSelectors.getCustomParams)(state).formFields,
    stagedFormState: state.stagedFormState,
    formStateValidation: (0, _FormFieldValidationSelector.getStagedFormFieldValidation)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    legalConsentEnabled: (0, _BookInfoSelectors.getCustomParams)(state).legalConsentEnabled,
    offline: (0, _BookInfoSelectors.getOffline)(state),
    userTimezone: state.userTimezone
  };
}, FormActions)(PropertyForm);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/sections/PropertyForm.js
// module id = 232
// module chunks = 0